import { createSelector } from '@reduxjs/toolkit';

import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const currentChatMlSearchSessionGuidSelector = createSelector(
  [currentOpenChatSelector],
  currentOpenChat => currentOpenChat?.ga?.mlSearchSessionGuid,
);
